import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useNotificationStore } from '@autobid/nuxt-pinia-store/store/useNotificationStore'
import {
  useWebSocketStore,
} from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'
import { useAddNotification } from './notifications/useAddNotification'

type NotificationEventName =
  'premium.CAR_OVERBID' |
  'premium.CAR_WATCHED_SOON_IN_HOTBID' |
  'premium.CAR_ACTIVE_SOON_IN_HOTBID' |
  'premium.USER_BOUGHT_CAR' |
  'premium.USER_NOT_BOUGHT_CAR' |
  'premium.DOCUMENT_PICKUP' |
  'premium.USER_SOLD_CAR' |
  'premium.CAR_RESERVED' |
  'premium.USER_NOT_SOLD_CAR' |
  'premium.USER_SEARCH_CRITERIA_FOUND_CAR' |
  'premium.DOCUMENT_INVOICE' |
  'premium.USER_BOUGHT_CAR_RESERVED' |
  'premium.CAR_WATCHED_FINISHED' |
  'premium.TRANSPORT_REMINDER'

interface EventData {
  templateType: number
  name: NotificationEventName
}

export function useNotificationsSocket() {
  const { isAuthed } = useAutobidAuth()
  const { startListen } = useWebSocketStore()
  const { addNotification } = useAddNotification()
  const { amountOfNotificationsToSync } = storeToRefs(useNotificationStore())

  const listenNotificationsEvents = () => {
    if (!isAuthed.value)
      return

    if (typeof window.Notification !== 'undefined') {
      Notification.requestPermission()
    }

    const LIST_OF_EVENTS: EventData[] = [
      {
        templateType: 1,
        name: 'premium.CAR_OVERBID',
      },
      {
        templateType: 2,
        name: 'premium.CAR_WATCHED_SOON_IN_HOTBID',
      },
      {
        templateType: 3,
        name: 'premium.CAR_ACTIVE_SOON_IN_HOTBID',
      },
      {
        templateType: 4,
        name: 'premium.USER_BOUGHT_CAR',
      },
      {
        templateType: 5,
        name: 'premium.USER_NOT_BOUGHT_CAR',
      },
      {
        templateType: 6,
        name: 'premium.DOCUMENT_PICKUP',
      },
      {
        templateType: 7,
        name: 'premium.USER_SOLD_CAR',
      },
      {
        templateType: 8,
        name: 'premium.CAR_RESERVED',
      },
      {
        templateType: 9,
        name: 'premium.USER_NOT_SOLD_CAR',
      },
      {
        templateType: 10,
        name: 'premium.USER_SEARCH_CRITERIA_FOUND_CAR',
      },
      {
        templateType: 11,
        name: 'premium.DOCUMENT_INVOICE',
      },
      {
        templateType: 12,
        name: 'premium.USER_BOUGHT_CAR_RESERVED',
      },
      {
        templateType: 13,
        name: 'premium.CAR_WATCHED_FINISHED',
      },
      {
        templateType: 14,
        name: 'premium.TRANSPORT_REMINDER',
      },
    ]

    for (const eventData of LIST_OF_EVENTS) {
      startListen({
        eventName: eventData.name,
        callbackName: 'notification-center',
        callback: (event: { input?: string }) => {
          addNotification({
            type: eventData.templateType,
            eventInput: event.input,
          })
        },
      })
    }

    startListen({
      eventName: 'premium.USER_NEW_NOTIFICATION',
      callbackName: 'notification-center',
      callback: () => {
        amountOfNotificationsToSync.value++
      },
    })
  }

  onMounted(() => {
    listenNotificationsEvents()
  })
}
